import React, { Component, Fragment } from "react";
import { withRouter } from 'react-router-dom';
import { correctcircleRed } from './../../assets'

import GenAIDisplayString from './AuthoringEnableDisplayString'
import { Modal } from "react-bootstrap";
import GenAIAnsweringPreview from "../Preview/GenAIAnsweringPreview"

import trackingService from "../../services/trackingService";

import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "../PopUp/ConfirmMessagePopUpModal";
import OpenWindow from '../OpenWindow';
import GenerateArrayStrings from "../GenerateArrayStrings";
import NotebookListPopUp from "../PopUp/NotebookListPopUp";
import 'tippy.js/dist/tippy.css'; // optional


class GenAIResultIndex extends Component {
    constructor(props) {
        // this.messagesEndRef = createRef()
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            Question: props.Question,
            OutputAnswer: props.OutputAnswer,
            // Sources: props.Sources,
            // DisplayString: props.DisplayString,
            isShowMore: false,
            selectedSource: null,
            selectedPageNumber: [],
            showPreviewModel: false,
            isInEditMode: false,
            updatedQuestion: props.Question,
            conversationIndex: props.conversationIndex,
            eventid: props.eventid,
            isMultiFiles: props.isMultiFiles,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            isCopiedAns: false,
            confirmMessageContent: '',
            confirmMessageShowModal: false,
            confirmMessageId: -1,
            lastCreatedDatehour: props.lastCreatedDatehour,
            RelevantInformation: props.RelevantInformation,
            ShowRelevantInformation: props.ShowRelevantInformation,
            isImageThread: props.isImageThread,
            savingSummarizeText: '',
            savingCommandType: 'QnA',
            savingOrignalText: '',
            savingCommandText: '',
            savingReference: '',
            showNotebookList: false,
            isLoaded: true,
        }
    }
    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {

        if (nextProps.lastCreatedDatehour !== this.props.lastCreatedDatehour) {
            this.setState({ lastCreatedDatehour: nextProps.lastCreatedDatehour });
        }

    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    showConfirmMessage = (message, id) => {
        this.setState({
            confirmMessageContent: message,
            confirmMessageShowModal: true,
            confirmMessageId: id
        })
    }

    confirmHandler = async () => {
        this.setState(
            {
                confirmMessageContent: "",
                confirmMessageShowModal: false,
                // confirmMessageId: -1
            },
            async () => {

            }
        );
    }

    closeConfirmMessage = () => {
        this.setState({
            confirmMessageContent: "",
            confirmMessageShowModal: false,
            confirmMessageIndex: -1
        })
    }



    renderModelPopup() {
        const { showPreviewModel, selectedSource, selectedPageNumber, attachedFiles, isMultiFiles } = this.state;
        return (<Modal
            show={showPreviewModel}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="answering-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}>
            <Modal.Body>
                <div style={{ overflow: "auto" }}>
                    <GenAIAnsweringPreview selectedSource={selectedSource}
                        selectedPageNumber={selectedPageNumber}
                        attachedFiles={attachedFiles}
                        isMultiFiles={isMultiFiles}
                        handleClose={this.handlePreviewClose} />
                </div>
            </Modal.Body>
        </Modal>)
    }
    handleClickOnSourceNumber = (singleSource, pageNumbers, DisplayString) => {

        pageNumbers = pageNumbers.sort((a, b) => a - b);
        const { attachedFiles, isMultiFiles, eventid } = this.state;
        let prviewObject = {
            selectedSource: singleSource,
            selectedPageNumber: pageNumbers,
            attachedFiles: attachedFiles,
            isMultiFiles: isMultiFiles,
            DisplayString: DisplayString,
            isRecommendation: false,
        }
        let _id = "";
        if (isMultiFiles && singleSource.document_guid) {
            _id = singleSource.document_guid
        } else if (singleSource.searchID) {
            _id = singleSource.searchID
        }
        if (eventid && _id) {
            let width = 0.99 * window.innerWidth
            let height = 1.05 * window.innerHeight
            let left = 0.05 * window.innerWidth
            let top = 0.05 * window.innerHeight
            let windowPreview = window.open(`/genAIAnsweringPreview/${eventid}?docid=${_id}`, '', `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
            windowPreview[`${eventid}-${_id}`] = prviewObject;
        }
    }
    handlePreviewClose = async () => {
        this.setState({ showPreviewModel: false },
            async () => {
                setTimeout(() => {
                    document.body.classList.remove('custome-modal-open');
                }, 1000);
            })
    }
    extractNCTId = (protocolIdsArr = []) => {
        var pidNCTArray = [];
        var pidStream = "";
        var nctStream = "";
        let nctId = protocolIdsArr?.filter((elm) => elm.startsWith("NCT"));
        let pIds = protocolIdsArr?.filter((elm) => !elm.startsWith("NCT"));
        if (pIds.length > 0) {
            pidStream = pIds.toString().split(",").join(";");
        }
        if (nctId.length > 0) {
            nctStream = nctId.toString().split(",").join(";");
        }
        pidNCTArray.push(pidStream);
        pidNCTArray.push(nctStream);
        return pidNCTArray;
    };
    handleProtocolID = (protocolIDs) => {
        let ids = GenerateArrayStrings(protocolIDs);
        let queryIds = protocolIDs.join(" OR ");
        let url =
            window.location.origin +
            `/results?query=${queryIds}&sbQuery=&q=All%20Fields&filters=&f1=protocolIDs&fval1=${ids}&fcount=1`;
        OpenWindow(url);
    }

    indexDownloadData = (event) => {
        var docTitle = [event.target.getAttribute("data-title")];
        var searchID = [event.target.getAttribute("data-docid")];
        var url = [event.target.getAttribute("data-docurl")];
        var docNumber = [event.target.getAttribute("data-docNumber")];
        let { eventid } = this.state;
        let { sessionID, Question, questionType, threadID } = this.props;
        let assistantinfo = {
            "session_id": sessionID,
            "thread_id": threadID,
            "question_type": questionType,
            "question": Question,
            "eventid": eventid
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'),
            localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'),
            localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'),
            localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'),
            `View OR Download Answering2.0 Document`, '',
            window.location.href,
            '',
            '',
            docTitle, '', docNumber, searchID, url, '', '', `View OR Download Answering2.0 Document`, '', '', '', '', '', '', '', '', {}, {}, assistantinfo);
    };
    indexMultiFilesDocumentPreview = (docTitle) => {
        let { sessionID, Question, questionType, threadID } = this.props;
        let { eventid } = this.state;
        let assistantinfo = {
            "session_id": sessionID,
            "thread_id": threadID,
            "question_type": questionType,
            "question": Question,
            "ismultifiles": true,
            "eventid": eventid
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'),
            localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'),
            localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'),
            localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'),
            `Preview Answering2.0 Document`, '',
            window.location.href,
            '',
            '',
            docTitle, '', '', '', '', '', '', `Preview Answering2.0 Document`, '', '', '', '', '', '', '', '', {}, {}, assistantinfo);
    };
    indexDocumentPreview = (docTitle, searchID, url, docNumber) => {
        let { eventid } = this.state;
        let { sessionID, Question, questionType, threadID } = this.props;
        let assistantinfo = {
            "session_id": sessionID,
            "thread_id": threadID,
            "question_type": questionType,
            "question": Question,
            "ismultifiles": false,
            "eventid": eventid,
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'),
            localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'),
            localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'),
            localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'),
            `Preview Answering2.0 Document`, '',
            window.location.href,
            '',
            '',
            docTitle, '', docNumber, searchID, url, '', '', `Preview Answering2.0 Document`, '', '', '', '', '', '', '', '', {}, {}, assistantinfo);
    };


    renderRelevantInformation = () => {
        let { RelevantInformation } = this.state;
        let { eventid, ShowRelevantInformation } = this.state;

        return (<div id={`gen-ai-enable-authoring-main-answer-renderRelevantInformation-${eventid}`}>
            {Object.keys(RelevantInformation).filter((x, i) => { return (ShowRelevantInformation || i < 1) }).map((conversation, conversationIndex) => {
                let { Sources, DisplayString } = RelevantInformation[conversation];
                return (<Fragment key={`renderRelevantInformation-${conversationIndex}`}>
                    {this.renderRelevantInformationDisplayString(Sources, DisplayString, conversationIndex)}
                </Fragment>)
            })}
        </div>)
    }

    renderRelevantInformationDisplayString = (Sources, DisplayString, ansIndex) => {
        let { eventid } = this.state;
        let { sessionID, Question, questionType, threadID } = this.props;
        if (DisplayString.length > 0) {
            return (<div className="gen-ai-enable-authoring-main-answer-wrapper-relevant-information" id={`resultMainAnswer${eventid}`}>
                {DisplayString.map((dsitem, dsindex) => {
                    //dsitem.display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                    dsitem.display_ans = dsitem.display_ans.replace(/<li><br>/g, '<li>')
                    dsitem.display_ans = dsitem.display_ans.replace(/<sup><b style='background-color:lightblue'>\s\s<\/b><\/sup>/g, '')
                    return (<GenAIDisplayString key={`gen-ai-enable-authoring-main-answer${dsindex}`}
                        displayAns={dsitem.display_ans} sourceNo={dsitem.source_no}
                        pageNumber={dsitem.page_number} sources={Sources}
                        isMultiFiles={false} eventid={eventid}
                        DisplayString={DisplayString}
                        sessionID={sessionID} Question={Question} questionType={questionType} threadID={threadID} />)
                })}
            </div>)
        } else {
            if (ansIndex === 0) {
                return (<div className="gen-ai-enable-authoring-main-answer-wrapper-relevant-information" id={`resultMainAnswer${eventid}`}>
                    No Answer found. Please try a new question.
                </div>)
            } else {
                return (<div className="gen-ai-enable-authoring-main-answer-wrapper-relevant-information" id={`resultMainAnswer${eventid}`}>
                    No more information found.
                </div>)
            }
        }
    }

    snippetLongStringForKeyword = (snippet, strLength = 35) => {
        if (snippet.length > strLength) {
            let text = snippet.substring(0, strLength)//cuts to 70
            text = text + `...`//adds (...) at the end to show that it's cut
            return text
        }
        return snippet;
    }

    indexData = (eventAction, answer_reaction, answer_feedback) => {
        let { eventid, isMultiFiles } = this.state;
        let { sessionID, Question, questionType, threadID, OutputAnswer, Sources, DisplayString, RelevantInformation } = this.props;
        let assistantinfo = {
            "session_id": sessionID,
            "thread_id": threadID,
            "question_type": questionType,
            "question": Question,
            "ismultifiles": isMultiFiles,
            "eventid": eventid,
            answer_reaction: answer_reaction,
            answer_feedback: answer_feedback,
            outputAnswer: OutputAnswer,
            sources: Sources,
            displayString: DisplayString,



            relevantInformation: RelevantInformation
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            eventAction,
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, {}, assistantinfo);

    }


    generateArrayString = (array) => {
        let arrStr = ''
        array.map((item, index) => {
            if (index === array.length - 1) {
                arrStr += item
            }
            else {
                arrStr += item + ";"
            }
            return null
        })
        return arrStr
    }

    handleCloseNotebookList = () => {
        this.setState({ showNotebookList: false, showNotebookPreviewList: false, isFromGlobalFeaturesMenuForNotebook: false });
    }

    render() {
        let { Question } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        const { confirmMessageContent, confirmMessageShowModal, showNotebookList } = this.state;
        const { savingSummarizeText, savingCommandType, savingOrignalText, savingCommandText, savingReference } = this.state;
        if (this.state.customWidth >= 600 && this.state.customWidth <= 1000) {
           return (<> <div className="gen-ai-enable-authoring-main">
                <div ref={(el) => { this.messagesEndRef = el; }} style={{ marginTop: "-50px" }}>&nbsp;</div>
                <div className={"gen-ai-enable-authoring-left"} >
                    <><div className="gen-ai-enable-authoring-question">
                        <h2 className="gen-ai-enable-authoring-question-h2">{Question}</h2>
                        <div className="gen-ai-enable-authoring-question-control-section">
                        </div>
                    </div>
                    </>
                    <><div className="gen-ai-enable-authoring-main-answer-main-relevant-information">
                        <div className="gen-ai-enable-authoring-main-answer-header">
                            <div className="gen-ai-enable-authoring-main-answer-header-icon">
                                <img src={correctcircleRed} alt="Loading Data" style={{ width: "24px" }} />

                            </div>
                            <div className="gen-ai-enable-authoring-main-answer-header-title">Summary</div>
                        </div>
                    </div>
                        {this.renderRelevantInformation()}
                    </>

                </div>

            </div >
                {this.renderModelPopup()}
                {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} btnText="Yes" />}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                {showNotebookList && <NotebookListPopUp showModal={showNotebookList} sourceItem={{}} summeryText={savingOrignalText}
                    summarizeText={savingSummarizeText} handleClose={this.handleCloseNotebookList} width={this.props.customWidth}
                    commandType={savingCommandType} commandText={savingCommandText} notesText={''} citationText={savingReference} />
                }
            </>)
        }
        else if (this.state.customWidth > 1000) {
            return (<> <div className="gen-ai-enable-authoring-main">
                <div ref={(el) => { this.messagesEndRef = el; }} style={{ marginTop: "-50px" }}>&nbsp;</div>
                <div className={"gen-ai-enable-authoring-left"} >
                    <><div className="gen-ai-enable-authoring-question">
                        <h2 className="gen-ai-enable-authoring-question-h2">{Question}</h2>
                        <div className="gen-ai-enable-authoring-question-control-section">
                        </div>
                    </div>
                    </>
                    <><div className="gen-ai-enable-authoring-main-answer-main-relevant-information">
                        <div className="gen-ai-enable-authoring-main-answer-header">
                            <div className="gen-ai-enable-authoring-main-answer-header-icon">
                                <img src={correctcircleRed} alt="Loading Data" style={{ width: "24px" }} />

                            </div>
                            <div className="gen-ai-enable-authoring-main-answer-header-title">Summary</div>
                        </div>
                    </div>
                        {this.renderRelevantInformation()}
                    </>

                </div>

            </div >
                {this.renderModelPopup()}
                {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} btnText="Yes" />}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                {showNotebookList && <NotebookListPopUp showModal={showNotebookList} sourceItem={{}} summeryText={savingOrignalText}
                    summarizeText={savingSummarizeText} handleClose={this.handleCloseNotebookList} width={this.props.customWidth}
                    commandType={savingCommandType} commandText={savingCommandText} notesText={''} citationText={savingReference} />
                }
            </>)
        }
    }
}
export default withRouter(GenAIResultIndex);